import { tokenName } from './theme.js'

// Legend 는 계열 이름과 색 견본을 한 줄로 늘어놓는다.
//
// uPlot 기본 범례는 끈다(TimeChart 의 legend.show=false). 그쪽은 값까지 함께 적는 표라
// 레인 여럿을 세로로 쌓는 화면에서 레인마다 높이를 먹는다. 여기서는 HTML 이라 색을
// var(--토큰) 으로 바로 쓴다 — 캔버스와 달리 테마가 바뀌어도 다시 풀 일이 없다.
export default function Legend({ items, className }) {
  return (
    <div className={`mops-chart-legend${className ? ` ${className}` : ''}`}>
      {items.map((it) => (
        <span key={it.key ?? it.label} className="mops-chart-legend__item">
          <i className={`mops-chart-legend__swatch${it.dash ? ' is-dash' : ''}`}
            style={{ '--swatch': `var(${tokenName(it.color)})` }} />
          {it.label}
        </span>
      ))}
    </div>
  )
}
